import React from 'react';
import { Image, Font, Link, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import logo from "../img/logo-01.png"

// Create styles
const styles = StyleSheet.create({
    table: {
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
    },
    row: {
        display: "flex",
        flexDirection: "row",
    },
    cell: {
        padding: 5,
        textAlign: "center",
        fontSize: "11px",
        height: "auto"
    },
    header: {
        backgroundColor: "#4e8373",
        fontWeight: 700,
        color: "white",
        minHeight: "30px",
        fontSize: "12px",
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    header2: {
        backgroundColor: "#2777cc",
        fontWeight: 700,
        color: "white",
        minHeight: "30px",
        fontSize: "12px",
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    cantidad: {
        width: "40px",
        textAlign: "center"
    },
    desc: {
        width: "60px",
        marginRight: "10px",
        textAlign: "center"
    },
    descripcion: {
        width: "40%",
        textAlign: "left",
    },
    flexibleCell: {
        flex: 1
    },
    info: {
        fontSize: "9px",
        color: "gray"
    },
    page: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        backgroundColor: '#E4E4E4',
        minHeight: '100vh',
        minWidth: '100vw',
        padding: "30px",
        paddingBottom: "45px"
    },
    section: {
        marginTop: 5,
        marginBottom: 5,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 12,
    },
    nocotizacion: {
        color: "red",
    },
    adorno: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "50px",
        width: "100px",
        overflow: "hidden"
    },
    minadorno: {
        display: "block",
        width: "100px",
        height: "12px",
        borderRadius: "10px",
        backgroundColor: "#95b5ab",
        marginLeft: "-15px"
    },
    minadorno2: {
        display: "block",
        width: "100px",
        height: "12px",
        borderRadius: "10px",
        backgroundColor: "#619bd8",
        marginLeft: "-15px"
    },
    titulo: {
        color: "#4e8373",
        fontWeight: 700,
        fontSize: "20px",
        marginTop: "15px",
        paddingBottom: "5px",
        marginBottom: "10px",
        // borderBottomColor: "#95b5ab",
        // borderBottomStyle: "solid",
        // borderBottomWidth: "2px",
    },
    titulo2: {
        color: "#2777cc",
        fontWeight: 700,
        fontSize: "20px",
        marginTop: "15px",
        paddingBottom: "5px",
        marginBottom: "10px",
        // borderBottomColor: "#95b5ab",
        // borderBottomStyle: "solid",
        // borderBottomWidth: "2px",
    },
    divider: {
        height: "5px",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        borderBottomColor: "#95b5ab",
        borderBottomStyle: "solid",
        borderBottomWidth: "2px",
    },
    divider2: {
        height: "5px",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        borderBottomColor: "#2777cc",
        borderBottomStyle: "solid",
        borderBottomWidth: "2px",
    },
    footer: {
        position: "absolute",
        bottom: 30,
        right: 30,
        textAlign: "center",
        fontSize: 12,
    },
    totalBox: {
        width: "60%",
        marginLeft: "40%",
        marginTop: "20px",
        fontSize: "14px",
    },

    txtViewTotal: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        borderBottomColor: "#95b5ab",
        borderBottomWidth: "1px",
        marginBottom: "10px"
    },
    txtViewTotal2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        borderBottomColor: "#619bd8",
        borderBottomWidth: "1px",
        marginBottom: "10px"
    },
    totaltexttitle: {
        fontSize: "15px"
    },
    separadorTitulo: {
        fontSize: "12px",
        fontWeight: "bold",
        margin: "5px 0"
    }


});

const hyphenationCallback = (word) => {
    return word.replace(/([aeiouy])(?=[^aeiouy])/gi, '$1-').split('-');
};

Font.registerHyphenationCallback(hyphenationCallback);

// Create Document Component
export const ReactPdfDocument = (params) => {
    let convertir = require('numero-a-letras');

    let base = {
        opciones: {
            tipoFactura: "normal",
            dividida: false
        },
        datosCliente: {
            nombre: "",
            direccion: "",
            cotizacion: "",
            nombrevendedor: "",
            contactovendedor: ""
        },
        articulos: [],
        totales: {
            subtotal1: "0",
            descuento: "0",
            importe: "",
            instalacion: "",
            subtotal2: "0",
            iva: "0",
            total: ""
        },
        totalesDistribuidor: {
            subtotal1: "0",
            total: "0",
        }
    };

    if (params.base) {
        base = params.base
    }
    const parseStringToFloat = (str) => {
        // Reemplazar las comas (,) por nada y convertir el string a número flotante
        return parseFloat(str.replace(/,/g, ''));
    };

    function capitalizeWords(str) { return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '); }
    // console.log(base)

    // Suma de porcentaje
    const porcentplus = (part, total) => {
        // console.log(part);
        // console.log(total);

        return total + ((part * total) / 100)
    }

    const formatNumber = (num) =>
        num.toLocaleString("en-US", {
            minimumFractionDigits: 2, // Al menos 2 decimales
            maximumFractionDigits: 2, // Máximo 2 decimales
            useGrouping: true,       // Usar separación de miles
        });

    // Calcula el ISR
    const handleISR = (element) => {
        return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.015).toFixed(2)
    }

    // Calcula el IVA
    const handleIVA = (element) => {
        return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.16).toFixed(2)
    }

    function esString(variable) {
        return Object.prototype.toString.call(variable) === "[object String]";
    }

    return (
        <Document
            fileName='Hola'
            title='Cotizacion A House Interior'
            author='Norma Lydia Aldana Gomez'
            subject='Cotizacion'
            keywords='Cotizacion'
            creator='Abdiel Aldana'
            producer='Aurora Amethyst'
            pdfVersion="1.0"
            language='es-MX'
            pageMode='fullScreen'
            pageLayout='singlePage'
        >
            <Page size="A4" style={styles.page} wrap
                orientation='portrait'>

                <View fixed style={[styles.section, { display: "flex", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center" }]}>

                    {params.tipo == "2" ?
                        <View
                            style={styles.adorno}
                        >
                            <Link style={styles.minadorno2}>a</Link>
                            <Link style={styles.minadorno2}>a</Link>
                            <Link style={styles.minadorno2}>a</Link>
                        </View>
                        :
                        <View
                            style={styles.adorno}
                        >
                            <Link style={styles.minadorno}>a</Link>
                            <Link style={styles.minadorno}>a</Link>
                            <Link style={styles.minadorno}>a</Link>
                        </View>
                    }
                    <Image
                        cache
                        src={logo}
                        style={{ height: '40px', width: 'auto', margin: "0 auto" }}
                    />
                    <View style={{ textAlign: "right" }}>
                        <View style={{ width: "100px", textAlign: "center", display: "flex", justifyContent: "flex-end" }}>
                            <Text style={{ textAlign: "right" }}>No.<Text style={styles.nocotizacion}> {base.datosCliente.cotizacion}  </Text></Text>
                        </View>
                        <View style={{ width: "100px", textAlign: "right", display: "flex", justifyContent: "flex-end" }}>
                            <Text style={{ textAlign: "right" }}><Text>{base.datosCliente.fecha}  </Text></Text>
                        </View>
                    </View>
                </View>

                <View style={{ textAlign: 'center' }}>
                    {params.tipo == "2" ?
                        <Text style={styles.titulo2}>COTIZACIÓN</Text>
                        :
                        <Text style={styles.titulo}>COTIZACIÓN</Text>
                    }
                </View>

                {params.tipo == "2" ? <View style={styles.divider2}></View> : <View style={styles.divider}></View>}

                <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <View style={{ width: "70%", textAlign: "left" }}>
                        <Text style={{ fontSize: "10px", fontWeight: 700 }}>Cliente:</Text>
                        <Text style={{ color: params.tipo == "2" ? "#2777cc" : "#4e8373", fontSize: "14px" }}>{base.datosCliente.nombre}</Text>
                        <Text style={{ fontSize: "12px" }}>{capitalizeWords(base.datosCliente.direccion)}</Text>

                    </View>
                    <View style={{ width: "30%", textAlign: "right" }}>
                        {params.tipo == "2" && <Text style={{ color: params.tipo == "2" ? "#2777cc" : "#4e8373", fontSize: "14px" }}>Distribuidor</Text>}
                    </View>
                </View>

                {params.tipo == "2" ? <View style={styles.divider2}></View> : <View style={styles.divider}></View>}

                <View style={styles.table}>
                    {/* Fila de encabezado */}
                    {(params.tipo == "1") &&
                        <View style={[styles.row, styles.header]} fixed>
                            <Text style={[styles.cell, styles.cantidad]}>Cnt.</Text>
                            <Text style={[styles.cell, styles.descripcion]}>Descripcion General</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Subtotal</Text>
                            <Text style={[styles.cell, styles.desc]}>Desc.</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Total</Text>
                        </View>
                    }
                    {(params.tipo == "2") &&
                        <View style={[styles.row, styles.header2]} fixed>
                            <Text style={[styles.cell, styles.cantidad]}>Cnt.</Text>
                            <Text style={[styles.cell, styles.descripcion]}>Descripcion General</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Subtotal</Text>
                            <Text style={[styles.cell, styles.desc]}>Desc.</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Total</Text>
                        </View>
                    }
                    {params.tipo == "3" &&
                        <View style={[styles.row, styles.header]} fixed>
                            <Text style={[styles.cell, styles.cantidad]}>Cnt.</Text>
                            <Text style={[styles.cell, styles.descripcion]}>Descripcion General</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Ancho</Text>
                            <Text style={[styles.cell, styles.desc]}>Alto</Text>
                            <Text style={[styles.cell, styles.flexibleCell]}>Metros<sup>2</sup></Text>
                        </View>
                    }
                    {/* Fila de datos */}
                    {base.articulos.map((row, index) => {

                        if (row.tipo == "persiana") {
                            return (
                                <React.Fragment key={index}>
                                    <View wrap={false} style={[styles.row, { borderBottomWidth: "1px", borderBottomColor: "gray", break: 'avoid', }]}>
                                        <Text style={[styles.cell, styles.cantidad]}>{row.cantidad}</Text>
                                        <View style={[styles.cell, styles.descripcion]}>
                                            <Text style={{ color: params.tipo == "2" ? "#2777cc" : "#4e8373", marginBottom:"5px" }}>{capitalizeWords(row.descripcion.trimStart())}</Text>
                                            <Text style={styles.info}>Area: {capitalizeWords(row.area)}</Text>
                                            {(params.tipo == "2") &&                                            
                                                <Text style={styles.info}>Alto: {row.medida.alto}m | Ancho: {row.medida.ancho}m </Text>
                                            }
                                            {(params.tipo == "1" || params.tipo == "2") &&
                                                <Text style={styles.info}>Precio M<Text style={{ fontSize: 7, position: 'relative', marginTop: "-3px" }}>2</Text>: ${row.precio.m2}</Text>
                                            }
                                            {(params.tipo == "1" || params.tipo == "2") &&
                                                <Text style={styles.info}>Precio Unitario: ${row.precio.unitario}</Text>
                                            }
                                            
                                            {/* <Text style={styles.info}>Precio Vistas: ${row.precio.vistas}</Text> */}
                                        </View>

                                        {(params.tipo == "1" || params.tipo == "2") &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>${row.precio.subtotal}</Text>
                                            </View>
                                        }

                                        {params.tipo == "1" &&
                                            <View style={[styles.cell, styles.desc]}>
                                                <Text>{row.descuento.primero}%</Text>
                                                {(row.descuento.compartido != 0 || row.descuento.compartido != "0") &&
                                                    <Text><Text style={styles.info}>Adi.</Text> {row.descuento.compartido}%</Text>
                                                }
                                            </View>
                                        }

                                        {params.tipo == "2" &&
                                            <View style={[styles.cell, styles.desc]}>
                                                <Text>{row.distribuidor.descuento.primero}%</Text>
                                                {(row.distribuidor.descuento.compartido != 0 || row.distribuidor.descuento.compartido != "0") &&
                                                    <Text><Text style={styles.info}>Adi.</Text> {row.distribuidor.descuento.compartido}%</Text>
                                                }
                                            </View>
                                        }

                                        {params.tipo == "1" &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>${row.precio.total}</Text>
                                            </View>
                                        }

                                        {params.tipo == "2" &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>${row.distribuidor.precio.total}</Text>
                                            </View>
                                        }

                                        {params.tipo == "3" &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>{row.medida.ancho}</Text>
                                            </View>
                                        }
                                        {params.tipo == "3" &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>{row.medida.alto}</Text>
                                            </View>
                                        }
                                        {params.tipo == "3" &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>{row.medida.m2.toFixed(2)}</Text>
                                            </View>
                                        }
                                    </View>
                                </React.Fragment>
                            )
                        }
                        if (row.tipo == "articulo") {
                            return (
                                <React.Fragment key={index}>
                                    <View wrap={false} style={[styles.row, { borderBottomWidth: "1px", borderBottomColor: "gray", break: 'avoid', }]}>
                                        <Text style={[styles.cell, styles.cantidad]}>{row.cantidad}</Text>
                                        <View style={[styles.cell, styles.descripcion]}>
                                            <Text style={{ color: params.tipo == "2" ? "#2777cc" : "#4e8373" }}>{capitalizeWords(row.nombre)}</Text>
                                            {row.datos.descripcion !== "" || row.datos.datosextra !== "" &&
                                                <Text style={styles.info}>{capitalizeWords(row.datos.descripcion)} - {capitalizeWords(row.datos.datosextra)}</Text>
                                            }
                                            {/* <Text style={styles.info}></Text> */}
                                            {(params.tipo == "1" || params.tipo == "2") &&
                                                <Text style={styles.info}>Precio Unitario: ${row.precio.precioUnitario}</Text>
                                            }
                                            {/* <Text style={styles.info}>Precio Unitario: ${row.precio.precio}</Text>
                                            <Text style={styles.info}>Precio Vistas: ${row.precio.vistas}</Text> */}
                                        </View>
                                        {(params.tipo == "1" || params.tipo == "2") &&
                                            <View style={[styles.cell, styles.flexibleCell]}>
                                                <Text>${row.precio.subtotal}</Text>
                                            </View>
                                        }
                                        {params.tipo == "1" &&
                                            <View style={[styles.cell, styles.desc]}>
                                                <Text>{row.precio.descuento}%</Text>
                                                {row.precio.descuentoAd != 0 &&
                                                    <Text>Ad. {row.precio.descuentoAd}%</Text>
                                                }
                                            </View>
                                        }
                                        {params.tipo == "2" &&
                                            <View style={[styles.cell, styles.desc]}>
                                                <Text>{row.precioDistribuidor.descuento}%</Text>
                                                {row.precioDistribuidor.descuentoAd != 0 &&
                                                    <Text>Ad. {row.precioDistribuidor.descuentoAd}%</Text>
                                                }
                                            </View>
                                        }
                                        {/* <View style={[styles.cell, styles.flexibleCell]}>
                                        </View> */}
                                        {params.tipo == "1" &&
                                            <Text style={[styles.cell, styles.flexibleCell]}>${row.precio.total}</Text>
                                        }
                                        {params.tipo == "2" &&
                                            <Text style={[styles.cell, styles.flexibleCell]}>${row.precioDistribuidor.total}</Text>
                                        }
                                    </View>
                                </React.Fragment>
                            )
                        }
                        if (row.tipo == "seccion") {
                            return (
                                <React.Fragment key={index}>
                                    <View wrap={false} style={[styles.row, { borderBottomWidth: "1px", borderBottomColor: "gray", break: 'avoid', }]}>
                                        <Text style={[styles.cell, styles.flexibleCell, styles.separadorTitulo]}>{capitalizeWords(row.nombre)}{row.piso !== "" ? " - " + row.piso + " " : "" }</Text>
                                    </View>
                                </React.Fragment>
                            )
                        }
                    })}
                </View>

                <View wrap={false} style={styles.totalBox}>
                    <View>

                        {/* SubTotal */}
                        {(params.tipo == "1" && base.opciones.tipoFactura !== "normal") &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Subtotal:</Text>
                                <Text>${base.totales.subtotal1}</Text>
                            </View>
                        }
                        {(params.tipo == "2" && base.opciones.tipoFactura !== "normal") &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Subtotal:</Text>
                                <Text>${base.totalesDistribuidor.subtotal1}</Text>
                            </View>
                        }

                        {/* IVA */}
                        {(params.tipo == "1" && (base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr")) &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>IVA:</Text>
                                <Text>+16%</Text>
                                <Text>{formatNumber(parseStringToFloat(base.totales.subtotal1) * 0.16)}</Text>
                            </View>
                        }
                        {(params.tipo == "2" && (base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr")) &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>IVA:</Text>
                                <Text>+16%</Text>
                                <Text>{formatNumber(parseStringToFloat(base.totalesDistribuidor.subtotal1) * 0.16)}</Text>
                            </View>
                        }


                        {/* ISR */}
                        {(params.tipo == "1" && base.opciones.tipoFactura == "isr") &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>ISR:</Text>
                                <Text>-1.5%  0</Text>
                                <Text>${formatNumber(parseStringToFloat(base.totales.subtotal1) * 0.015)}</Text>
                            </View>
                        }
                        {(params.tipo == "2" && base.opciones.tipoFactura == "isr") &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>ISR:</Text>
                                <Text>-1.5%  0</Text>
                                <Text>${formatNumber(parseStringToFloat(base.totalesDistribuidor.subtotal1) * 0.015)}</Text>
                            </View>
                        }

                        {/* TOTAL */}
                        {params.tipo == "1" &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Total:</Text>
                                <Text>${base.totales.total}</Text>
                            </View>
                        }
                        {/* {params.tipo == "1" &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Anticipo:</Text>
                                <Text>$80,000.00</Text>
                            </View>
                        }
                        {params.tipo == "1" &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Total:</Text>
                                <Text>{formatNumber(parseStringToFloat(base.totales.total) - 80000)}</Text>
                            </View>
                        } */}
                        {params.tipo == "2" &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Total:</Text>
                                <Text>${base.totalesDistribuidor.total}</Text>
                            </View>
                        }
                        {/* {base.totales.anticipo != 100 &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Anticipo:</Text>
                                <Text>${base.totales.anticipoTotal}</Text>
                            </View>
                        }
                        {base.totales.anticipo != 100 &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>Restante:</Text>
                                <Text>${base.totales.pagoFinal}</Text>
                            </View>
                        } */}

                        {/* TOTAL EN LETRAS */}
                        {params.tipo == "1" &&
                            <View>
                                {/* <Text style={{ fontSize: "9px", color: "gray", textAlign: "center" }}>{convertir.NumerosALetras(parseStringToFloat(base.totales.total) - 80000 )}</Text> */}
                                <Text style={{ fontSize: "9px", color: "gray", textAlign: "center" }}>{convertir.NumerosALetras(parseStringToFloat(base.totales.total))}</Text>
                            </View>
                        }
                        {params.tipo == "2" &&
                            <View>
                                <Text style={{ fontSize: "9px", color: "gray", textAlign: "center" }}>{convertir.NumerosALetras(parseStringToFloat(base.totalesDistribuidor.total))}</Text>
                            </View>
                        }
                    </View>

                </View>

                <View fixed style={{ marginTop: "auto", width: "100%", borderTopColor: "gray", borderTopWidth: "1px" }}>
                    <Text style={{ textAlign: "center", marginTop: "5px", fontSize: "10px" }}>
                        {base.datosCliente.vendedor} - {base.datosCliente.contactovendedor}
                    </Text>
                </View>
                <View fixed style={[styles.section, { display: "flex", borderTopColor: "gray", borderTopWidth: "1px", flexDirection: "row", justifyContent: "space-evenly", alignItems: "flex-start", fontSize: "8px" }]}>
                    <View style={{ width: "90%" }}>
                        <Text style={{ textAlign: "left", marginTop: "5px" }}>
                            Términos y Condiciones – A House Interior
                        </Text>
                        <Text style={{ textAlign: "justify", marginTop: "10px" }}>
                            Los precios mostrados estan sujetos a cambios sin previo aviso. Esta cotización es válida hasta el último día del mes en curso o un maximo de 4 días. A House Interior no se hace responsable por el mal uso de esta cotización al compartir con terceros. La recepción de esta cotización implica la aceptación de los términos y condiciones aquí descritos.
                        </Text>
                        <Link src='https://ahouseinterior.com/' style={{ textAlign: "center", marginTop: "10px" }}>
                            www.ahouseinterior.com
                        </Link>
                    </View>
                </View>

                <Text
                    style={styles.footer}
                    render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
                    fixed
                />

            </Page>

        </Document>
    );
}

